export function isAdmin(user) {
  return user?.role === 'admin'
}

export function isManager(user) {
  return user?.role === 'manager'
}

export function isStaff(user) {
  return user?.role === 'staff'
}

export function canManageParts(user) {
  return isAdmin(user) || isManager(user)
}

export function canAdjustStock(user) {
  return canManageParts(user)
}

export function canTransact(user) {
  if (isAdmin(user) || isManager(user)) return true
  return isStaff(user) && user?.permissions?.canTransact === true
}

export function canManageUsers(user) {
  return isAdmin(user)
}

export function canManageProjects(user) {
  return isAdmin(user) || isManager(user)
}

export function canManageRequests(user) {
  return isAdmin(user) || isManager(user)
}

export const ROLE_OPTIONS = [
  { value: 'admin', label: '관리자' },
  { value: 'manager', label: '매니저' },
  { value: 'staff', label: '직원' },
]

export function roleLabel(role) {
  return ROLE_OPTIONS.find((item) => item.value === role)?.label || role || '-'
}
